import * as React from "react";

export const Attachment = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.07419 6.95062C1.6683 8.35651 1.6683 10.6359 3.07419 12.0418C4.48008 13.4477 6.75947 13.4477 8.16536 12.0418L13.2919 6.91527C14.2096 5.99753 14.2096 4.5096 13.2919 3.59186C12.3742 2.67413 10.8862 2.67413 9.96848 3.59186L5.19551 8.36483C4.9612 8.59915 4.9612 8.97905 5.19551 9.21336C5.42983 9.44768 5.80972 9.44768 6.04404 9.21336L10.817 4.44039C11.2661 3.99129 11.9943 3.99129 12.4434 4.44039C12.8925 4.88949 12.8925 5.61763 12.4434 6.06674L7.31683 11.1933C6.37957 12.1305 4.85998 12.1305 3.92272 11.1933C2.98546 10.256 2.98546 8.73641 3.92272 7.79915L7.45825 4.26362C7.69257 4.0293 7.69257 3.6494 7.45825 3.41509C7.22394 3.18077 6.84404 3.18077 6.60972 3.41509L3.07419 6.95062Z"
    />
);
